// extracted by mini-css-extract-plugin
export default {"keyValueDisplay":"key-value-display__keyValueDisplay","item":"key-value-display__item"};